import { render, staticRenderFns } from "./MultiPackageItem.vue?vue&type=template&id=b84a8f66&scoped=true"
import script from "./MultiPackageItem.vue?vue&type=script&lang=js"
export * from "./MultiPackageItem.vue?vue&type=script&lang=js"
import style0 from "./MultiPackageItem.vue?vue&type=style&index=0&id=b84a8f66&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84a8f66",
  null
  
)

export default component.exports